import { render } from "./UserEnrolProjectComponent.vue?vue&type=template&id=6aaaa9b0"
import script from "./UserEnrolProjectComponent.vue?vue&type=script&lang=js"
export * from "./UserEnrolProjectComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__